import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { DOWNLOAD_DISK_O_PROMO_CONFIG, IS_DOCUMENTS_DOMAIN } from 'reactApp/appHelpers/configHelpers';
import { cloudFilesMigrationDesktop } from 'reactApp/appHelpers/featuresHelpers/features/cloudFilesMigrationDesktop';
import { DEMO_PROMO_VARIANT } from 'reactApp/appHelpers/featuresHelpers/features/demoPromo';
import { marchPromo2026SidebarButton } from 'reactApp/appHelpers/featuresHelpers/features/marchPromo2026';
import { unlimitedDocsFakedoorConfig } from 'reactApp/appHelpers/featuresHelpers/features/unlimitedDocuments';
import { useIsFreemium } from 'reactApp/hooks/useFreemium';
import { useMarchPromo2026 } from 'reactApp/hooks/useMarchPromo2026';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { DemoPromo } from 'reactApp/ui/DemoPromo/DemoPromo';
import { useDiscountTimer } from 'reactApp/ui/DiscountInOutflow/DiscountTimer/useDiscountTimer';
import { FreemiumSidebarBanner } from 'reactApp/ui/FreemiumSidebarBanner/FreemiumSidebarBanner';
import { MarchPromo2026SidebarBanner } from 'reactApp/ui/MarchPromo2026SidebarBanner/MarchPromo2026SidebarBanner';
import { TelegramMigrationSidebarBanner } from 'reactApp/ui/TelegramMigrationSidebarBanner/TelegramMigrationSidebarBanner';
import { TrialPromo } from 'reactApp/ui/TrialPromo/TrialPromo';
import { UnlimitedDocumentsBanner } from 'reactApp/ui/UnlimitedDocuments/UnlimitedDocumentsBanner/UnlimitedDocumentsBanner';
import { useUnlimitedDocumentsBanner } from 'reactApp/ui/UnlimitedDocuments/UnlimitedDocumentsBanner/useUnlimitedDocumentsBanner';

import { useShow1tbPromo } from './useShow1tbPromo';

export const useLeftBlockTopPromo = () => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);
    const show1tbTrialPromo = useShow1tbPromo();
    const [isLeftBlockTopPromoVisible, setIsLeftBlockTopPromoVisible] = useState(true);
    const { isLoaded: isDiscountTimerShowInfoLoaded, element: timerElement } = useDiscountTimer(setIsLeftBlockTopPromoVisible);
    const { show: showUnlimitedDocumentsBanner } = useUnlimitedDocumentsBanner();
    const isFreemium = useIsFreemium() && !IS_DOCUMENTS_DOMAIN && storage !== EStorageType.family;
    const { isLoaded: isBillingLoaded } = useSelector(BillingDataSelectors.getBillingDataLoadingState);
    const isLoaded = isDiscountTimerShowInfoLoaded;
    const isMarchPromo2026 = useMarchPromo2026();
    const isBizUser = useSelector(UserSelectors.isBizUser);

    const leftBlockTopPromo = useMemo(() => {
        if (!isLoaded || !isBillingLoaded) {
            return null;
        }
        // тут должны быть либо статические условия, либо надо проверить их актуальность через isLoaded,
        // чтобы заранее не отрендерить элемент ниже в очереди, пока условие временно будет false
        switch (true) {
            case cloudFilesMigrationDesktop && !isBizUser:
                return <TelegramMigrationSidebarBanner />;
            case marchPromo2026SidebarButton && isMarchPromo2026:
                return <MarchPromo2026SidebarBanner />;
            case showUnlimitedDocumentsBanner:
                return <UnlimitedDocumentsBanner type={unlimitedDocsFakedoorConfig.type} setVisible={setIsLeftBlockTopPromoVisible} />;
            case !!DEMO_PROMO_VARIANT:
                return <DemoPromo setVisible={setIsLeftBlockTopPromoVisible} />;
            case !!timerElement:
                return timerElement;
            case isFreemium:
                return <FreemiumSidebarBanner />;
            case show1tbTrialPromo:
                return (
                    <TrialPromo
                        text="+1 ТБ на месяц бесплатно"
                        href={DOWNLOAD_DISK_O_PROMO_CONFIG?.treePromoLink}
                        setVisible={setIsLeftBlockTopPromoVisible}
                    />
                );
            default:
                return null;
        }
    }, [isLoaded, isBillingLoaded, isBizUser, isMarchPromo2026, showUnlimitedDocumentsBanner, timerElement, isFreemium, show1tbTrialPromo]);

    return { leftBlockTopPromo, isLeftBlockTopPromoVisible };
};
